var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.chart)?_c('pie-chart',{attrs:{"data":_vm.chart.data,"donut":true,"legend":_vm.showLegend ? _vm.posLegend : null,"colors":_vm.chart.colors}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }